import React from 'react';
import type { IconName } from '../../types/content';
interface ContentIconProps {
  name: IconName;
  className?: string;
}
const paths: Record<IconName, React.ReactNode> = {
  spike: <path d="M2 18l4-2 3-12 4 14 3-6 6 6" data-id="element-383" data-mp="11p437yovd12c" />,
  lock: <>
      <rect x="4" y="10" width="16" height="10" rx="2" data-id="element-384" data-mp="11nkmk6zawo01" />
      <path d="M8 10V7a4 4 0 018 0v3" data-id="element-385" data-mp="16g3wmtys5103" />
    </>,
  clock: <>
      <circle cx="12" cy="12" r="8" data-id="element-386" data-mp="16hf351jm0muw" />
      <path d="M12 8v4l3 2" data-id="element-387" data-mp="1bf6xe27q8l29" />
    </>,
  loop: <>
      <path d="M4 10a8 8 0 0113.6-3.6L20 9" data-id="element-388" data-mp="1bgrotiyqvnvw" />
      <path d="M20 14a8 8 0 01-13.6 3.6L4 15" data-id="element-389" data-mp="1gd8lx2nx9cl4" />
      <path d="M20 5v4h-4M4 19v-4h4" data-id="element-390" data-mp="1gbxb4iw274ki" />
    </>,
  sun: <>
      <circle cx="12" cy="12" r="4" data-id="element-391" data-mp="1lclbhv66gxre" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" data-id="element-392" data-mp="1ldmklu3mva6h" />
    </>,
  moon: <path d="M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z" data-id="element-393" data-mp="1pc3w0pu376tp" />,
  sunrise: <>
      <path d="M12 4v3M5.6 8.6l1.4 1.4M18.4 8.6L17 10M3 18h18M7 18a5 5 0 0110 0" data-id="element-394" data-mp="3n5sr75ppdhdt" />
    </>,
  science: <>
      <path d="M9 3h6M10 3v6l-5 8a3 3 0 002.6 4.5h8.8A3 3 0 0019 17l-5-8V3" data-id="element-395" data-mp="3r63472bwx826" />
      <path d="M7 15h10" data-id="element-396" data-mp="381tc8n70r1kb" />
    </>,
  dna: <>
      <path d="M7 3c0 6 10 6 10 12M17 3c0 6-10 6-10 12M7 21h.01M17 21h.01" data-id="element-397" data-mp="33abb9z4zx0zc" />
      <path d="M8.5 7h7M8.5 17h7" data-id="element-398" data-mp="3388bwohydvhy" />
    </>,
  stethoscope: <>
      <path d="M6 3v5a5 5 0 0010 0V3" data-id="element-399" data-mp="2yc9s7e7kl1nv" />
      <path d="M11 13v3a4 4 0 008 0v-2" data-id="element-400" data-mp="2y94524ii49us" />
      <circle cx="19" cy="11" r="2" data-id="element-401" data-mp="2tcndf0c3fdcy" />
    </>,
  chart: <>
      <path d="M4 20V4M4 20h16" data-id="element-402" data-mp="2ta10el6fo5nc" />
      <path d="M8 16v-4M12 16V8M16 16v-6" data-id="element-403" data-mp="3r0ffo8q0d4re" />
    </>,
  book: <>
      <path d="M4 5a2 2 0 012-2h12v18H6a2 2 0 01-2-2z" data-id="element-404" data-mp="3qxt5e1bqgb5h" />
      <path d="M8 7h7M8 11h7" data-id="element-405" data-mp="3m1ueo72xmh1w" />
    </>,
  code: <>
      <path d="M9 7l-5 5 5 5M15 7l5 5-5 5" data-id="element-406" data-mp="3lyyc25g53474" />
    </>,
  map: <>
      <path d="M9 4l6 2 5-2v14l-5 2-6-2-5 2V6z" data-id="element-407" data-mp="3h0522n029vbp" />
      <path d="M9 4v14M15 6v14" data-id="element-408" data-mp="3c2vd18gl3loe" />
    </>,
  eye: <>
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" data-id="element-409" data-mp="3c23lq9u0sa3x" />
      <circle cx="12" cy="12" r="2.5" data-id="element-410" data-mp="25mt2wpf8y0vv" />
    </>,
  brake: <>
      <circle cx="12" cy="12" r="8" data-id="element-411" data-mp="25k6p481rip57" />
      <path d="M12 8v8M8.5 12h7" data-id="element-412" data-mp="20n6oicnomelh" />
    </>,
  cycle: <>
      <circle cx="12" cy="12" r="7" data-id="element-413" data-mp="20pswgdehiw48" />
      <path d="M12 5v7l4 2" data-id="element-414" data-mp="snrb8nfpo2n1" />
      <path d="M19 8l-2.5.5" data-id="element-415" data-mp="soissuch3zub" />
    </>
};
export function ContentIcon({
  name,
  className = 'h-5 w-5'
}: ContentIconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" focusable="false" data-id="element-416" data-mp="wn9tfbg5dzm6">
      {paths[name]}
    </svg>;
}